/* ── HAYLOU CI — theme.js ── */
(function(){
  /* Header scroll */
  const header = document.querySelector('.site-header');
  if(header){
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  /* Mobile menu */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if(hamburger && mobileNav){
    hamburger.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      const spans = hamburger.querySelectorAll('span');
      if(mobileNav.classList.contains('open')){
        spans[0].style.transform = 'rotate(45deg) translate(5px,5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px,-5px)';
      } else {
        spans.forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
      }
    });
    document.addEventListener('click', (e) => {
      if(!hamburger.contains(e.target) && !mobileNav.contains(e.target)){
        mobileNav.classList.remove('open');
        hamburger.querySelectorAll('span').forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
      }
    });
  }

  /* FAQ accordion */
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if(!isOpen) item.classList.add('open');
    });
  });

  /* Reviews auto-scroll */
  const track = document.querySelector('.reviews-track');
  if(track){
    let pos = 0;
    let isPaused = false;
    track.addEventListener('mouseenter', () => isPaused = true);
    track.addEventListener('mouseleave', () => isPaused = false);
    setInterval(() => {
      if(isPaused) return;
      pos += 0.5;
      if(pos >= track.scrollWidth - track.clientWidth) pos = 0;
      track.scrollLeft = pos;
    }, 16);
  }

  /* Video placeholder */
  const playBtn = document.querySelector('.play-btn');
  if(playBtn){
    playBtn.addEventListener('click', () => {
      const wrap = playBtn.closest('.video-wrap');
      const videoId = wrap.dataset.videoId;
      if(videoId){
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;';
        wrap.querySelector('.video-placeholder').replaceWith(iframe);
      }
    });
  }

  /* Product gallery thumbnails */
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = document.querySelector('.product-main-img img');
      if(mainImg && thumb.querySelector('img')){
        mainImg.src = thumb.querySelector('img').src;
      }
    });
  });

  /* Quantity buttons */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-input').querySelector('.qty-num');
      let val = parseInt(input.value) || 1;
      if(btn.dataset.action === 'minus') val = Math.max(1, val - 1);
      if(btn.dataset.action === 'plus') val++;
      input.value = val;
    });
  });

  /* Newsletter form */
  const newsletterForm = document.querySelector('.newsletter-form');
  if(newsletterForm){
    newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = newsletterForm.querySelector('.btn-subscribe');
      btn.textContent = '✓ Abonné !';
      btn.style.background = '#25D366';
      setTimeout(() => {
        btn.textContent = "Je m'abonne";
        btn.style.background = '';
        newsletterForm.reset();
      }, 3000);
    });
  }

  /* Add to cart button feedback */
  document.querySelectorAll('.btn-cart, .btn-add-to-cart').forEach(btn => {
    btn.addEventListener('click', function(e){
      const originalText = this.textContent;
      this.textContent = '✓ Ajouté !';
      this.style.background = '#25D366';
      setTimeout(() => {
        this.textContent = originalText;
        this.style.background = '';
      }, 2000);
    });
  });

  /* Variant selection — bloque réellement les couleurs/options indisponibles */
  const variantsJsonEl = document.getElementById('product-variants-json');
  if (variantsJsonEl) {
    const variants = JSON.parse(variantsJsonEl.textContent);
    const optionGroups = Array.from(document.querySelectorAll('.variant-options'));
    const variantIdInput = document.getElementById('variant-id-input');
    const addToCartBtn = document.getElementById('add-to-cart-btn');
    const buyNowBtn = document.getElementById('buy-now-btn');

    // État courant : valeur sélectionnée pour chaque index d'option
    const selected = [];
    optionGroups.forEach(group => {
      const idx = parseInt(group.dataset.optionIndex, 10);
      const activeBtn = group.querySelector('.variant-btn.active') || group.querySelector('.variant-btn:not([disabled])');
      selected[idx] = activeBtn ? activeBtn.dataset.value : null;
    });

    function findVariant(selectionArray) {
      return variants.find(v => {
        const opts = [v.option1, v.option2, v.option3].filter(o => o !== null && o !== undefined);
        return opts.every((o, i) => o === selectionArray[i]);
      });
    }

    function isValueAvailable(optionIndex, value) {
      // Une valeur est dispo s'il existe au moins une variante disponible
      // qui combine cette valeur avec les AUTRES options déjà sélectionnées
      return variants.some(v => {
        const opts = [v.option1, v.option2, v.option3];
        if (opts[optionIndex] !== value) return false;
        return opts.every((o, i) => {
          if (i === optionIndex) return true;
          if (o === null || o === undefined) return true;
          if (selected[i] === null || selected[i] === undefined) return true;
          return o === selected[i];
        }) && v.available;
      });
    }

    function refreshUI() {
      // Met à jour la disponibilité visuelle de chaque bouton
      optionGroups.forEach(group => {
        const idx = parseInt(group.dataset.optionIndex, 10);
        group.querySelectorAll('.variant-btn').forEach(btn => {
          const available = isValueAvailable(idx, btn.dataset.value);
          btn.disabled = !available;
          btn.classList.toggle('disabled', !available);
          btn.classList.toggle('active', btn.dataset.value === selected[idx]);
        });
        const labelEl = group.closest('div').querySelector('.variant-selected-value');
        if (labelEl && selected[idx]) labelEl.textContent = selected[idx];
      });

      const matched = findVariant(selected);
      if (matched) {
        variantIdInput.value = matched.id;
        const available = matched.available;
        if (addToCartBtn) {
          addToCartBtn.disabled = !available;
          addToCartBtn.textContent = available ? 'Ajouter au panier' : 'Épuisé';
        }
        if (buyNowBtn) buyNowBtn.disabled = !available;
      } else {
        // Aucune combinaison valide correspondante
        if (addToCartBtn) { addToCartBtn.disabled = true; addToCartBtn.textContent = 'Indisponible'; }
        if (buyNowBtn) buyNowBtn.disabled = true;
      }
    }

    document.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const group = btn.closest('.variant-options');
        const idx = parseInt(group.dataset.optionIndex, 10);
        selected[idx] = btn.dataset.value;
        refreshUI();
      });
    });

    refreshUI();
  }

  /* Animate on scroll */
  if('IntersectionObserver' in window){
    const els = document.querySelectorAll('.product-card,.feature-card,.cat-card,.trust-item,.review-card');
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, {threshold:0.1});
    els.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity .5s ease, transform .5s ease';
      obs.observe(el);
    });
  }
})();
